export const LAYOUT_CYCLE_DELAY = 1000;
export const LAYOUT_CYCLE_INTERVAL = 700;

export const CANVAS_ROTATION_TRANSITION_DURATION = 500;
